import { Link, generatePath } from 'react-router-dom';

import { Button, LoadingSpinner } from '@kanda-libs/ks-design-library';

import { URLS } from 'config';

import ApplyCard from '../components/Card';

export interface SucecssProps {
  showButton: boolean;
  id?: string;
}

const Sucecss: React.FunctionComponent<SucecssProps> = function ({
  showButton,
  id,
}) {
  return (
    <ApplyCard noBottomPadding flex>
      <div className="flex flex-1 pt-8 pb-12">
        <div className="flex flex-col m-auto">
          <p className="text-20-24-em">Processing Application</p>
          <LoadingSpinner stroke="purple-300" className="mx-auto mt-6" />
          {showButton && (
            <Link
              to={generatePath(URLS.status, { id })}
              className="mx-auto mt-6"
            >
              <Button.Text
                id="apply-submitting-status"
                label="Check status"
                icon="arrow-right"
              />
            </Link>
          )}
        </div>
      </div>
    </ApplyCard>
  );
};

export default Sucecss;
